// @ts-check
import { nextArrow, prevArrow, options } from "@/global/slick-options";
import { getAll } from "@/utilities/querySelector";

/**
 * @param {HTMLElement} slider
 * @param {jQueryStatic} $
 */
export function initialiseSlider(slider, $) {
    const size = slider.getAttribute("data-slider-size");
    const additionalOptions = JSON.parse(slider.getAttribute('data-slider-options') ?? '{}');

    let customOptions = {};
    let defaultOptions = {
        ...options,
        nextArrow,
        prevArrow
    };

    if (size === "tiny") {
        customOptions = {
            ...defaultOptions,
            slidesToShow: 6,
            responsive: [
                {
                    breakpoint: 1300,
                    settings: {
                        slidesToShow: 6,
                    }
                },
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 400,
                    settings: {
                        slidesToShow: 2,
                    }
                }
            ],
        };
    } else if (size === "small") {
        customOptions = {
            ...defaultOptions,
            slidesToShow: 4,
            responsive: [
                {
                    breakpoint: 1535,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1250,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 850,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ],
        };
    } else if (size == "medium") {
        customOptions = {
            ...defaultOptions,
            slidesToShow: 3,
            responsive: [
                {
                    breakpoint: 1535,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1250,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 850,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ],
        };
    } else if (size == "large") {
        customOptions = {
            ...defaultOptions,
            slidesToShow: 1.33,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                    }
                },
            ],
        };
    } else if (size == "huge") {
        customOptions = {
            fade: true,
            ...defaultOptions,
            speed: 300,
            slidesToShow: 1,
            pauseOnHover: false,
            infinite: true
        };
    }

    $(slider).slick({
        ...customOptions,
        ...additionalOptions
    });

}


jQuery(function ($) {
    const sliders = getAll('[data-card-slider]');
    sliders.forEach((slider) => {
        initialiseSlider(slider, $);
    });
});




if (isSmallScreen()) {
    const attachCardListeners = () => {
        const teamCards = getAll('.card--team-member');
        teamCards.forEach(card => {
            card.removeEventListener('click', toggleCardActiveState);
            card.addEventListener('click', toggleCardActiveState);
            console.log('Card listener attached');
        });
    };

    // Attach listeners to initial cards
    attachCardListeners();

    // Handle dynamically loaded cards when "Load More" buttons are clicked
    const loadMoreButtons = getAll('.archive-load-more');
    loadMoreButtons.forEach(button => {
        button.addEventListener('click', () => {
            setTimeout(() => {
                attachCardListeners();
            }, 1000);
        });
    });
}

function toggleCardActiveState(e) {
    e.currentTarget.classList.toggle('active');
    console.log('Card clicked');
}

function isSmallScreen() {
    return window.matchMedia('(max-width: 1024px)').matches;
}